import app from './en-US/app';
import menu from './en-US/menu';
import pages from './en-US/pages';

export default {
  ...app,
  ...menu,
  ...pages,
};
